import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: "8vw",
  },
  containerRTL: {
    marginLeft: 0,
    marginRight: "8vw",
    justifyContent: "flex-end",
  },
  checkbox: {
    margin: 5,
    width: "29vw",
    minWidth: 250,
    fontSize: "$option_icon_size",
  },
});
